import { useState } from 'react';
import { Submission, Participant, ParticipantGroup } from '../types';

export function useModalState() {
    const [showUserInfoForm, setShowUserInfoForm] = useState(false);
    const [selectedSubmission, setSelectedSubmission] = useState<Submission | null>(null);
    const [modalSeekTime, setModalSeekTime] = useState<string | undefined>(undefined);
    const [modalHighlight, setModalHighlight] = useState<string | undefined>(undefined);
    const [submissionToShare, setSubmissionToShare] = useState<Submission | null>(null);
    const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);
    const [showResearcherOnboarding, setShowResearcherOnboarding] = useState(false);
    const [viewingParticipant, setViewingParticipant] = useState<Participant | null>(null);
    const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
    const [editingGroup, setEditingGroup] = useState<ParticipantGroup | null>(null);

    return {
        showUserInfoForm, setShowUserInfoForm,
        selectedSubmission, setSelectedSubmission,
        modalSeekTime, setModalSeekTime,
        modalHighlight, setModalHighlight,
        submissionToShare, setSubmissionToShare,
        isAddProjectModalOpen, setIsAddProjectModalOpen,
        showResearcherOnboarding, setShowResearcherOnboarding,
        viewingParticipant, setViewingParticipant,
        isGroupModalOpen, setIsGroupModalOpen,
        editingGroup, setEditingGroup,
    };
}
